import * as React from 'react';
import {Platform, StyleSheet, Text, TouchableOpacity} from 'react-native';
import FontAwesome5Pro from 'react-native-vector-icons/FontAwesome5Pro';
import Styles from '../../Styles';
import Localized from 'src/constants/AppStrings';
const color = Platform.select({
  web: Styles.gray60,
  default: Styles.white,
});
type Props = {
  onPress: () => void;
};
export default function RecentOrdersButton(props: Props) {
  return (
    <TouchableOpacity onPress={props.onPress} style={styles.recentOrderButton}>
      <FontAwesome5Pro
        name="calendar-alt"
        color={color}
        size={Styles.Fonts.f2 * 0.8}
        light
        style={styles.recentOrderIcon}
      />
      <Text style={styles.recentOrderText}>
        {Localized.Buttons.recent_orders}
      </Text>
    </TouchableOpacity>
  );
}
const styles = StyleSheet.create({
  recentOrderButton: {
    flexDirection: 'row',
  },
  recentOrderText: {
    color,
    marginLeft: Styles.Spacing.m2,
    fontSize: Styles.Fonts.f2,
    lineHeight: Styles.Fonts.f3,
  },
  recentOrderIcon: {
    alignSelf: 'center',
  },
});
